// extracted by mini-css-extract-plugin
module.exports = {"contentCollapsed":"index--contentCollapsed"};